import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { initialCommAutoCertificateofInsuranceState } from "./commAutoCertificateofInsurance.types";
import { fetchCommAutoCertificateOfInsuranceList } from "./commAutoCertificateofInsuranceActions";

const commAutoCertificateofInsuranceSlice = createSlice({
  name: "commAutoCertificateofInsurance",
  initialState: initialCommAutoCertificateofInsuranceState,
  reducers: {
    clearCommAutoCertificateofInsuranceState: (state) => {
      return initialCommAutoCertificateofInsuranceState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchCommAutoCertificateOfInsuranceList.pending,
      (state) => {
        state.loading = LoadState.InProgress;
        state.certificateOfInsuranceList = [];
      },
    );
    builder.addCase(
      fetchCommAutoCertificateOfInsuranceList.fulfilled,
      (state, action) => {
        state.loading = LoadState.Loaded;
        state.certificateOfInsuranceList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      },
    );
    builder.addCase(
      fetchCommAutoCertificateOfInsuranceList.rejected,
      (state) => {
        state.loading = LoadState.Failed;
      },
    );
  },
});

export const { clearCommAutoCertificateofInsuranceState } =
  commAutoCertificateofInsuranceSlice.actions;

export const commAutoCertificateofInsuranceReducer =
  commAutoCertificateofInsuranceSlice.reducer;
